import { ApiClient } from "#/shared/api/client";
import { Result } from "#ce/components/SpCheckout/models/result";

export class PurchaseApi extends ApiClient {
  constructor() {
    super({ model: Result });
  }
}

export function createPurchaseApi() {
  const api = new PurchaseApi();

  return {
    // The checkout runs embedded on third-party host pages, so its requests are
    // cross-origin. The promo/expiration calls use CORS "simple" POSTs — body-less,
    // or form-encoded for applyPromoCode — because anything preflighted (PATCH, or a
    // JSON body) is dropped by some corporate proxies/security agents before it ever
    // reaches the server (see https://github.com/Atrium-Health/sparkle-create/issues/438).
    addToCart: async (url) => api.post(url),
    extendExpiration: async (url) => api.post(url),
    submitForm: async (url, data) => api.post(url, data),
    updateForm: async (url, data) => api.put(url, data),
    applyPromoCode: async (url, promoCode) => api.post(url, new URLSearchParams({ code: promoCode })),
    removePromoCode: async (url) => api.post(url),
    declineRsvp: async (url) => api.patch(url),
  };
}
